module.exports = __webpack_public_path__ + "img/map.c580172e.png";